import React from 'react';

export const sectionStyle: React.CSSProperties = {
  background: 'linear-gradient(135deg, #f0f7ff 0%, #f8fbff 100%)',
  borderRadius: 10,
  border: '1px solid #d4e4f7',
  padding: '16px',
  marginBottom: 16,
};

export const iconWrapperStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,
  borderRadius: 6,
  background: '#2CBDFF',
  color: '#fff',
  fontSize: 14,
};

export const segmentedTheme = {
  components: { Segmented: { itemSelectedBg: '#2CBDFF', itemSelectedColor: '#fff', trackBg: '#f0f0f0' } },
};

export const labelStyle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  color: '#8c8c8c',
  textTransform: 'uppercase',
  letterSpacing: 0.3,
  marginBottom: 2,
  display: 'block',
};

export const serviceGridColumns = '1fr 130px 70px 65px 80px 70px 70px 90px 90px 100px 32px';
